/** @jsxImportSource @emotion/react */

import {css} from "@emotion/react";
import {GuidlinesProps} from ".";
import GuidelinesSection from "./GuidelinesSection";
import YesNoButtons from "./YesNoButtons";
import approvedSvg from "assets/images/approved.svg";
import workerSvg from "assets/images/worker.svg";
import Ul from "./Ul";
import ButtonsContainer from "./ButtonsContainer";
import QuestionTitle from "./QuestionTitle";

export default function SkpGuidelines({onYes, onNo}: GuidlinesProps) {
  return (
    <div
      css={css`
        display: flex;
        gap: 5px;
        flex-direction: column;
      `}
    >
      <QuestionTitle>
        Does this risk location meet the guidelines outlined below?{" "}
      </QuestionTitle>
      <GuidelinesSection title="Eligibility requirements" svgUrl={approvedSvg}>
        <Ul>
          <li>Up to 7 employees (part time count as ½ employee)</li>
          <li>Up to 3 classes per risk</li>
          <li>
            Max sales (including receipts for work subcontracted to others) -
            $1.5MM
          </li>
          <li>Max payroll - $500K </li>
          <li>No exterior work over 3 stories </li>
          <li>NO GC's - Subcontracted work cannot exceed 20% of receipts</li>
          <li>
            Minimum of 3 years' experience required (start-ups are allowed)
          </li>
        </Ul>
      </GuidelinesSection>
      <GuidelinesSection title="Contractor Classes" svgUrl={workerSvg}>
        <Ul>
          <li>Air Conditioning/Heating Systems Work (NO LPG) (95647)</li>
          <li>Cabinet Makers (91342) </li>
          <li>Interior Decoration (96611)</li>
          <li>Carpentry (91342)</li>
          <li>Carpet/Floor Covering Installation (94569) </li>
          <li>Carpet/Rug/Upholstery Cleaning (91405) </li>
          <li>Concrete Construction (91560) </li>
          <li>Driveway, Sidewalk or Parking Area Paving or Repaving (92215)</li>
          <li>Drywall Installation (92338)</li>
          <li>Electric Household Appliance</li>
          <li>Electrical Wiring (Interior) (92475) </li>
          <li>Fence Installation (92476) </li>
          <li>Gas Household Appliance Installation/Repair (91155)</li>
          <li>Household Furnishings Installation/Repair (96053)</li>
          <li>Interior Decoration (96611)</li>
          <li>Janitorial Services (96816)</li>
          <li>Landscape Gardening (97047)</li>
          <li>Lawn Sprinkler Installation (97047)</li>
          <li>Masonry (97447)</li>
          <li>Office Machine Installation & Repair (98111)</li>
          <li>Painting & Paper Hanging (Exterior) (98304)</li>
          <li>Painting & Paper Hanging (Interior) (98305)</li>
          <li>Plaster/Stucco (98344)</li>
          <li>Plumbing (98483)</li>
          <li>Sheet Metal Work (95647)</li>
          <li>Siding Installation (91581) </li>
          <li>Tile, Stone, Terrazzo (99746)</li>
        </Ul>
      </GuidelinesSection>
      <ButtonsContainer>
        <YesNoButtons onYes={onYes} onNo={onNo} />
      </ButtonsContainer>
    </div>
  );
}
